export default __webpack_public_path__ + "static/media/digital-identity.25c144b5.svg";